import { SegmentationIds } from 'constants/segmentation';
import { InputProductType } from 'interfaces/api-input/input-product-type';
import { ProductType } from 'interfaces/product';

export default {
  'common:pieces': 'Stück',
  'common:allergies': 'Allergien',
  'common:name': 'Name',
  'common:name:mandatory': 'Pflichtfeld',
  'common:name:optional': 'Optional',
  'common:breed': 'Rasse',
  'common:age': 'Alter',
  'common:weight': 'Gewicht',
  'common:sterilization': 'Sterilisation',
  'common:body-condition': 'Körperzustand',
  'common:activity-level': 'Aktivitätslevel',
  'common:need': 'Bedürfnis',
  'common:back': 'Zurück',
  'common:close': 'Schließen',
  'common:submit': 'Speichern',
  'common:create': 'Erstellen',
  'common:and': 'und',
  'common:still': 'Noch',
  'common:add': 'Hinzufügen',
  'common:password': 'Kennwort',
  'common:password:optional': 'Kennwort (Optional)',
  'common:selected': 'Ausgewählt',
  'common:buttons:load-more': 'Mehr anzeigen',
  'common:buttons:learn-more': 'Mehr erfahren',
  'common:buttons:select': 'Bitte wählen',
  'common:buttons:cancel': 'Abbrechen',
  'common:buttons:back': 'Zurück',
  'common:buttons:continue': 'Weiter',
  'common:add-to-cart': 'In den Warenkorb',
  'common:products': 'Produkte',
  'common:promotions': 'Aktionen',
  'common:price:shipping': 'Versand',
  'common:price:totalPrice': 'Gesamtpreis',
  'common:price:tax': 'inkl. MwSt.',
  'common:price:totalWithTax': 'Gesamtbetrag inkl. MwSt.',
  'common:price:discount': 'Rabatt',
  'common:price:from': 'ab',
  'common:product:add': 'Hinzufügen',
  'common:product:variant': 'Variante',
  'common:product:quantity': 'Menge',
  'common:product:interval': 'Intervall',
  'common:product:size': 'Grösse',
  'common:product:to-the-porduct': 'Zum Produkt',
  'common:button:confrim': 'Bestätigen',
  'common:input:required': 'Pflichtfeld',
  'common:input:street:number-required': 'Straße muss mindestens eine Nummer enthalten',
  'common:input:street:letter-required': 'Straße muss mindestens einen Buchstaben enthalten',
  'common:input:street:min-length': 'Straße muss mindestens 2 Zeichen lang sein',
  'common:product:out-of-stock': 'Ausverkauft',
  'common:product:image-placeholder': 'Produktbild',
  'common:alt': 'Bild für',
  'common:product:bundle-contains': '<b>Probierpaket enthält</b> {productsList}',
  'common:address:shipping-address': 'Lieferadresse',
  'common:address:billing-address': 'Rechnungsadresse',
  'common:payment:payment-method': 'Zahlungsmethode',
  'common:unknown': 'Unbekannt',
  'common:loading': 'Lädt...',
  'common:country:de': 'Deutschland',
  'common:country:at': 'Österreich',
  'common:country:ch': 'Schweiz',
  'common:country:nl': 'Niederlande',
  'common:for-dogs': 'Für Hunde',
  'common:dogs': 'Hunde',
  'common:for-cats': 'Für Katzen',
  'common:cats': 'Katzen',
  'common:pet-type': 'Tierart',
  'common:pet-type:dog': 'Hund',
  'common:pet-type:cat': 'Katze',
  'common:birthday': 'Geburtstag',
  'common:add-item': 'Hinzufügen',
  'common:remove-item': 'Entfernen',
  'common:understood': 'Verstanden',
  'common:saved': 'Gespeichert',
  'common:error:failed-to-save': 'Speichern fehlgeschlagen. Bitte versuch es später erneut.',
  'common:undo': 'Rückgängig',
  'common:feed-type': 'Futterart',
  'common:taste': 'Geschmack',
  'common:consistency': 'Konsistenz',
  'common:snack': 'Snackart',

  'common:shop-switcher:title': 'Bist du auf dem richtigen Weg?',
  'common:shop-switcher:stay': 'Nein, hier bleiben',

  'common:shop-switcher:to:DE:button': 'Ja, zum deutschen Shop',
  'common:shop-switcher:to:DE:text':
    'Auf petsdeli.de sind Lieferungen nach Deutschland und Österreich möglich. Möchtest du zum deutschen Shop wechseln?',

  'common:shop-switcher:to:CH:button': 'Ja, zum Schweizer Shop',
  'common:shop-switcher:to:CH:text':
    'Auf petsdeli.ch sind Lieferungen in die Schweiz möglich. Möchtest du zum Schweizer Shop wechseln?',

  'common:shop-switcher:to:NL:button': 'Ja, zum niederländischen Shop',
  'common:shop-switcher:to:NL:text':
    'Auf petsdeli.nl sind Lieferungen in die Niederlande möglich. Möchtest du zum niederländischen Shop wechseln?',

  'common:tabs-accordeon:product-info': 'Produktinformation',
  'common:tabs-accordeon:product-info:plural': 'Produktinformationen',
  'common:product-info-preview:read-more': 'Mehr anzeigen',
  'common:product-info-preview:read-less': 'Weniger zeigen',
  'common:tabs-accordeon:badge-new': 'Neu',
  [`common:breed:${SegmentationIds.Bulldog}`]: 'Bulldoggen',
  [`common:breed:${SegmentationIds.Chihuahua}`]: 'Chihuahuas',
  [`common:breed:${SegmentationIds.Dachshund}`]: 'Dackel',
  [`common:breed:${SegmentationIds.Havanese}`]: 'Malteser',
  [`common:breed:${SegmentationIds.Poodle}`]: 'Pudel',
  [`common:breed:${SegmentationIds.Retriever}`]: 'Retriever',
  [`common:breed:${SegmentationIds.ShepherdDog}`]: 'Schäferhunde',
  [`common:breed:${SegmentationIds.Spitz}`]: 'Spitz',
  [`common:breed:${SegmentationIds.Terrier}`]: 'Terrier',
  [`common:breed:${SegmentationIds.Herdingdog}`]: 'Hütehunde',
  [`common:breed:${SegmentationIds.MixedLarge}`]: 'Mischling (groß)',
  [`common:breed:${SegmentationIds.MixedSmall}`]: 'Mischling (klein)',
  [`common:breed:${SegmentationIds.OtherBreed}`]: 'Andere Rasse',

  [`common:age:${SegmentationIds.Welpe}`]: 'Welpe',
  [`common:age:${SegmentationIds.DogAdult}`]: 'Adult',
  [`common:age:${SegmentationIds.DogSenior}`]: 'Senior',
  [`common:age:${SegmentationIds.Kitten}`]: 'Kitten',
  [`common:age:${SegmentationIds.CatAdult}`]: 'Adult',
  [`common:age:${SegmentationIds.CatSenior}`]: 'Senior',

  [`common:allergy:${SegmentationIds.GrainFree}`]: 'Getreide',
  [`common:allergy:${SegmentationIds.Beef}`]: 'Rind',
  [`common:allergy:${SegmentationIds.Chicken}`]: 'Huhn',
  [`common:allergy:${SegmentationIds.Duck}`]: 'Ente',
  [`common:allergy:${SegmentationIds.Fish}`]: 'Fisch',
  [`common:allergy:${SegmentationIds.Lamb}`]: 'Lamm',
  [`common:allergy:${SegmentationIds.Horse}`]: 'Pferd',
  [`common:allergy:${SegmentationIds.Goat}`]: 'Ziege',
  [`common:allergy:${SegmentationIds.SweetPotato}`]: 'Süßkartoffeln',
  [`common:allergy:${SegmentationIds.Potato}`]: 'Kartoffeln',
  [`common:allergy:${SegmentationIds.Poultry}`]: 'Geflügel',
  [`common:allergy:${SegmentationIds.Deer}`]: 'Hirsch',
  [`common:allergy:${SegmentationIds.Rabbit}`]: 'Kaninchen',
  [`common:allergy:${SegmentationIds.Veal}`]: 'Kalb',
  [`common:allergy:${SegmentationIds.Kangaroo}`]: 'Känguru',
  [`common:allergy:${SegmentationIds.Salmon}`]: 'Lachs',
  [`common:allergy:${SegmentationIds.Turkey}`]: 'Pute',
  [`common:allergy:${SegmentationIds.Tuna}`]: 'Thunfisch',
  [`common:allergy:${SegmentationIds.Game}`]: 'Wild',
  [`common:allergy:${SegmentationIds.Pork}`]: 'Schwein',

  [`common:product-type:${ProductType.WetFood}`]: 'Nassfutter',
  [`common:product-type:${ProductType.DryFood}`]: 'Trockenfutter',
  [`common:product-type:${ProductType.FoodSupplement}`]: 'Nahrungsergänzung',
  [`common:product-type:${ProductType.Med}`]: 'Med',
  [`common:product-type:${ProductType.FreshMenus}`]: 'BARF',
  [`common:product-type:${ProductType.Snacks}`]: 'Snacks',
  [`common:product-type:${ProductType.Accessories}`]: 'Zubehör',
  [`common:product-type:${ProductType.Gift}`]: 'Geschenk',
  [`common:product-type:${ProductType.Care}`]: 'Pflege',
  [`common:product-type:${ProductType.Testpaket}`]: 'Testpaket',
  [`common:product-type:${InputProductType.WetFood}`]: 'Nassfutter',
  [`common:product-type:${InputProductType.DryFood}`]: 'Trockenfutter',
  [`common:product-type:${InputProductType.FoodSupplement}`]: 'Nahrungsergänzung',
  [`common:product-type:${InputProductType.Med}`]: 'Med',
  [`common:product-type:${InputProductType.Barf}`]: 'BARF',
  [`common:product-type:${InputProductType.Snacks}`]: 'Snacks',
  [`common:product-type:${InputProductType.Accessories}`]: 'Zubehör',
  [`common:product-type:${InputProductType.Gift}`]: 'Geschenk',
  [`common:product-type:${InputProductType.Care}`]: 'Pflege',
  [`common:product-type:${InputProductType.TestPackage}`]: 'Testpaket',
  'common:bestseller': 'Bestseller',

  'common:hero-filter:nassfutter': 'Nassfutter',
  'common:hero-filter:trockenfutter': 'Trockenfutter',
  'common:hero-filter:barf': 'BARF',
  'common:hero-filter:snacks': 'Snacks',
  'common:hero-filter:all': 'Alle',

  'common:one-time-purchase:title': 'Einmalige Lieferung',

  'common:pet-profile:age-selector:title': 'Alter',
  'common:pet-profile:age-selector:chip:welpe': 'Welpe (0-1 Jahre)',
  'common:pet-profile:age-selector:chip:dog-adult': 'Adult (1-8 Jahre)',
  'common:pet-profile:age-selector:chip:senior': 'Senior (ab 8 Jahren)',
  'common:pet-profile:age-selector:chip:kitten': 'Kitten (0-1 Jahre)',
  'common:pet-profile:age-selector:chip:adultcat': 'Adult (1-10 Jahre)',
  'common:pet-profile:age-selector:chip:seniorcat': 'Senior (10+ Jahre)',
  'common:pet-profile:age-selector:desktop-age-selector:welpe': 'Junior',
  'common:pet-profile:age-selector:desktop-age-selector:description:welpe': 'bis 1 Jahr',
  'common:pet-profile:age-selector:desktop-age-selector:dog-adult': 'Adult',
  'common:pet-profile:age-selector:desktop-age-selector:description:dog-adult':
    'zwischen 1 und 8 Jahren',
  'common:pet-profile:age-selector:desktop-age-selector:senior': 'Senior',
  'common:pet-profile:age-selector:desktop-age-selector:description:senior': 'ab 8 Jahren',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.Kitten}`]: 'Kitten',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.CatAdult}`]: 'Adult',
  [`common:pet-profile:age-selector:desktop-age-selector:${SegmentationIds.CatSenior}`]: 'Senior',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.Kitten}`]:
    'bis 1 Jahr',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.CatAdult}`]:
    'zwischen 1 und 10 Jahre',
  [`common:pet-profile:age-selector:desktop-age-selector:description:${SegmentationIds.CatSenior}`]:
    '10+ Jahre',
  'common:pet-profile:sterilization-selector:title': 'Sterilisation status',
  'common:pet-profile:sterilization-selector:description:yes': 'Sterilisiert/Kastriert',
  'common:pet-profile:sterilization-selector:description:no': 'Nicht sterilisiert/kastriert',
  'common:pet-profile:sterilization-selector:chip:yes': 'Ja',
  'common:pet-profile:sterilization-selector:chip:no': 'Nein',
  'common:pet-profile:body-condition-selector:chip:1': 'Sehr schlank',
  'common:pet-profile:body-condition-selector:chip:2': 'Etwas zu schlank',
  'common:pet-profile:body-condition-selector:chip:3': 'Ideal in Form',
  'common:pet-profile:body-condition-selector:chip:4': 'Etwas rundlich',
  'common:pet-profile:body-condition-selector:chip:5': 'Gut gepolstert',
  'common:pet-profile:body-condition-selector:description:1': 'Sehr schlank',
  'common:pet-profile:body-condition-selector:description:2': 'Etwas zu schlank',
  'common:pet-profile:body-condition-selector:description:3': 'Ideal in Form',
  'common:pet-profile:body-condition-selector:description:4': 'Etwas rundlich',
  'common:pet-profile:body-condition-selector:description:5': 'Gut gepolstert',
  'common:pet-profile:activity-level-selector:chip:low': 'Wenig aktiv',
  'common:pet-profile:activity-level-selector:chip:medium': 'Normal aktiv',
  'common:pet-profile:activity-level-selector:chip:high': 'Sehr aktiv',
  'common:pet-profile:activity-level-selector:description:low': 'Wenig aktiv',
  'common:pet-profile:activity-level-selector:description:medium': 'Normal aktiv',
  'common:pet-profile:activity-level-selector:description:high': 'Sehr aktiv',
  'common:pet-profile:breed-selector:title': 'Bitte wähle eine Rasse:',
  [`common:pet-profile:breed-selector:${SegmentationIds.Bulldog}`]: 'Bulldogge',
  [`common:pet-profile:breed-selector:${SegmentationIds.Chihuahua}`]: 'Chihuahua',
  [`common:pet-profile:breed-selector:${SegmentationIds.Dachshund}`]: 'Dackel',
  [`common:pet-profile:breed-selector:${SegmentationIds.Havanese}`]: 'Havaneser & Malteser',
  [`common:pet-profile:breed-selector:${SegmentationIds.Herdingdog}`]: 'Hütehund',
  [`common:pet-profile:breed-selector:${SegmentationIds.MixedLarge}`]: 'Mischling (groß)',
  [`common:pet-profile:breed-selector:${SegmentationIds.MixedSmall}`]: 'Mischling (klein)',
  [`common:pet-profile:breed-selector:${SegmentationIds.Poodle}`]: 'Pudel & Pudelmix',
  [`common:pet-profile:breed-selector:${SegmentationIds.Retriever}`]: 'Retriever',
  [`common:pet-profile:breed-selector:${SegmentationIds.ShepherdDog}`]: 'Schäferhund',
  [`common:pet-profile:breed-selector:${SegmentationIds.Spitz}`]: 'Spitz',
  [`common:pet-profile:breed-selector:${SegmentationIds.Terrier}`]: 'Terrier',
  [`common:pet-profile:breed-selector:${SegmentationIds.OtherBreed}`]: 'Andere Rasse',
  'common:pet-profile:needs-selector:title': 'Bedürfnisse:',
  'common:pet-profile:needs-selector:pickyeater': 'Wählerisches Essverhalten',
  'common:pet-profile:needs-selector:overweight': 'Übergewicht',
  'common:pet-profile:needs-selector:intolerance': 'Allergien & Unverträglichkeiten',
  'common:pet-profile:needs-selector:intolerance-subtitle':
    'Wähle die Zutaten aus, auf die du verzichten möchtest (optional):',
  'common:pet-profile:needs-selector:digestion': 'Verdauungsprobleme',
  'common:pet-profile:needs-selector:skin-fur': 'Haut- & Fellprobleme',
  'common:pet-profile:needs-selector:pickyeater-description': 'Mäkelig, Unruhe, Blähungen',
  'common:pet-profile:needs-selector:overweight-description':
    'Trägheit, keine Taillenform erkennbar',
  'common:pet-profile:needs-selector:intolerance-description': 'Kratzen, Durchfall, Magengrummeln',
  'common:pet-profile:needs-selector:digestion-description':
    'Durchfall, Blähungen, Druckempfindlichkeit',
  'common:pet-profile:needs-selector:skin-fur-description': 'Kratzen, Lecken, Kahle Stellen',
  'common:pet-profile:needs-selector:prevention': 'Gesundheitsprävention',
  'common:pet-profile:needs-selector:prevention-description':
    'Immunsystem, Verdauungsbalance, Vitalität, Gelenke',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatPickyEater}`]: 'Wählerischer Esser',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatDigestion}`]: 'Verdauungsprobleme',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatOverweight}`]: 'Übergewicht',
  [`common:pet-profile:needs-selector:${SegmentationIds.SkinFurCat}`]: 'Haut- & Fellprobleme',
  [`common:pet-profile:needs-selector:${SegmentationIds.ImmuneSystem}`]: 'Immunity+',
  [`common:pet-profile:needs-selector:${SegmentationIds.IntoleranceCat}`]:
    'Allergien / Unverträglichkeiten',
  [`common:pet-profile:needs-selector:${SegmentationIds.HairballHelp}`]: 'Haarballen-Hilfe',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatPickyEater}-description`]:
    'Mäkelig, Unruhe, Blähungen',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatDigestion}-description`]:
    'Durchfall, Blähung, Verstopfung, Appetitlosigkeit',
  [`common:pet-profile:needs-selector:${SegmentationIds.CatOverweight}-description`]:
    'Trägheit, fehlende Taille, Gewichtszunahme',
  [`common:pet-profile:needs-selector:${SegmentationIds.ImmuneSystem}-description`]:
    'Unterstützung des Immunsystems',
  [`common:pet-profile:needs-selector:${SegmentationIds.IntoleranceCat}-description`]:
    'Kratzen, Durchfall, Magengrummeln',
  [`common:pet-profile:needs-selector:${SegmentationIds.SkinFurCat}-description`]:
    'Kratzen, Lecken, kahle Stellen',
  [`common:pet-profile:needs-selector:${SegmentationIds.HairballHelp}-description`]:
    'Unterstützt die Verdauung von Haarballen',
  'common:pet-profile:allergy': 'Unverträglichkeit',
  'common:show-more': 'Mehr anzeigen',
  'common:show-less': 'Weniger anzeigen',
};
